module.exports = __webpack_public_path__ + "static/img/11@3x.920be4f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/11@3x.png
// module id = 5f+E
// module chunks = 0